import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { CustomTranslateService } from '@services/common/custom-translate.service';
import { ClientAppConfig } from 'app/@types/shared/app-config';
import { ConfigService } from 'app/app-config.service';
import { forkJoin } from 'rxjs';

@Component({
    selector: 'app-freetrial-expiration',
    templateUrl: './freetrial-expiration.component.html',
    styleUrls: ['./freetrial-expiration.component.scss'],
})
export class FreetrialExpirationComponent {
    public client?: ClientAppConfig;
    public dCarbonizeMail: string;
    public mainColor: string;

    constructor(
        private configService: ConfigService,
        private router: Router,
        public translateService: CustomTranslateService,
    ) {
        this.client = this.configService.getClient;
        this.dCarbonizeMail = this.client.support?.mailDcarbonize ?? '';
        this.mainColor = this.client?.mainColor ?? '#3B82F6';
    }

    public onClickContactUs() {
        forkJoin([
            this.translateService.get('common.freetrialExpire.mail.subject'),
            this.translateService.get('common.freetrialExpire.mail.body'),
        ]).subscribe(([subject, body]) => {
            const mail = `mailto:${this.dCarbonizeMail}?&subject=${encodeURIComponent(
                subject as string,
            )}&body=${encodeURIComponent(body as string)}`;

            window.open(mail, 'emailWindow');
        });
    }
    public close(): void {
        this.router.navigate(['/auth/login'], { queryParams: { licenseExpired: false } });
    }
}
